import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import Moment from 'moment';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { TooltipMenu, Icon, Flex, Checkbox, Button } from '@haldor/ui';
import { Person } from 'UI';
import './MeetingUsers.scss';

var MeetingUsers = /*#__PURE__*/function (_Component) {
  _inherits(MeetingUsers, _Component);

  var _super = _createSuper(MeetingUsers);

  function MeetingUsers(props) {
    var _this;

    _classCallCheck(this, MeetingUsers);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "selectParticipant", function (user) {
      _this.props.onParticipantSelect(user);
    });

    _defineProperty(_assertThisInitialized(_this), "markForConversation", function (participant) {
      if (_this.props.onConversation != null) {
        _this.props.onConversation(participant);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getUserRoles", function (roles) {
      if (roles != null && roles.length > 0) {
        return roles.map(function (role, index) {
          if (role.roleId.toLowerCase() == 'school_administrator') {
            return null;
          }

          if (role.roleId.toLowerCase() == 'standard_curriculum_admin') {
            return null;
          }

          if (role.roleId.toLowerCase() == 'course_administrator') {
            return null;
          }

          if (role.roleId.toLowerCase() == 'conversation_admin') {
            return null;
          }

          if (role.roleId.toLowerCase() == 'sysadmin') {
            return null;
          }

          if (role.roleId.toLowerCase() == 'special_pedagogue') {
            return null;
          }

          return /*#__PURE__*/React.createElement("span", {
            key: role.roleId + index,
            style: {
              marginLeft: '.55rem'
            },
            className: "size-12 color--meta"
          }, _this.props.translate(role.roleId.toLowerCase()));
        });
      }

      return null;
    });

    return _this;
  }

  _createClass(MeetingUsers, [{
    key: "renderUsers",
    value: function renderUsers() {
      var _this2 = this;

      var _this$props = this.props,
          users = _this$props.users,
          meeting = _this$props.meeting,
          meetingInstance = _this$props.meetingInstance;
      return users.map(function (participant) {
        var user = participant.user;
        if (user == null) return null;
        var conversation = null;

        if (_this2.props.conversations != null) {
          conversation = _this2.props.conversations.find(function (conv) {
            return conv.memberships.find(function (member) {
              return member.membershipID == user.id;
            });
          });
        }

        var actions = [];

        if (_this2.props.services.conversations && _this2.props.onConversation != null && _this2.props.user.id != user.userId && !(_this2.props.isStudent && user.userType == 'GUARDIAN')) {
          actions.push({
            label: /*#__PURE__*/React.createElement("span", null, _this2.props.translate('manage-conversation'), conversation != null && conversation.unreadMessages > 0 ? ' (' + conversation.unreadMessages + ')' : null),
            onClick: function onClick() {
              return _this2.markForConversation(user);
            }
          });
        }

        if (_this2.props.onParticipantRemove != null && participant.userID != _this2.props.user.userId && meeting.creator === _this2.props.user.userId && !_this2.props.isStudent && meeting.status != 'COMPLETED') {
          actions.push({
            label: _this2.props.translate('Remove'),
            onClick: function onClick() {
              return _this2.props.onParticipantRemove(participant);
            }
          });
        }

        var roles = [];

        if (user.userType != 'GUARDIAN' && user.roles != null) {
          roles = user.roles;
          roles = roles.filter(function (thing, index, self) {
            return index === self.findIndex(function (t) {
              return t.roleId.toLowerCase() === thing.roleId.toLowerCase();
            });
          });
        }

        var name = /*#__PURE__*/React.createElement("span", null, user.firstName, " ", user.lastName != null ? user.lastName : null, _this2.getUserRoles(roles), user.userType == 'GUARDIAN' ? /*#__PURE__*/React.createElement("span", {
          style: {
            marginLeft: '.55rem'
          },
          className: "size-12 color--meta"
        }, _this2.props.translate('Guardian')) : null);
        return /*#__PURE__*/React.createElement("div", {
          style: {
            margin: '0.55rem 0'
          },
          key: 'user-' + user.id
        }, /*#__PURE__*/React.createElement(Flex, {
          center: true
        }, /*#__PURE__*/React.createElement("div", {
          className: "size-14 weight--bold",
          style: {
            flex: 1
          }
        }, !_this2.props.isStudent && meeting.status != 'COMPLETED' ? /*#__PURE__*/React.createElement(Checkbox, {
          value: participant.present,
          onChange: function onChange() {
            _this2.selectParticipant(participant);
          },
          label: name
        }) : /*#__PURE__*/React.createElement(Person, {
          person: user
        })), actions.length > 1 ? /*#__PURE__*/React.createElement(TooltipMenu, {
          trigger: /*#__PURE__*/React.createElement("div", {
            className: "list-user-actions"
          }, conversation != null && conversation.unreadMessages > 0 ? /*#__PURE__*/React.createElement("span", {
            className: "new-badge"
          }, conversation.unreadMessages) : null, /*#__PURE__*/React.createElement(Icon, {
            name: "Bullets"
          }))
        }, actions.map(function (action, index) {
          return /*#__PURE__*/React.createElement(TooltipMenu.Item, {
            key: index,
            onClick: action.onClick
          }, action.label);
        })) : /*#__PURE__*/React.createElement("div", null, actions.map(function (action, index) {
          return /*#__PURE__*/React.createElement(Link, {
            to: "#",
            style: {
              cursor: 'pointer'
            },
            onClick: action.onClick
          }, /*#__PURE__*/React.createElement("div", {
            style: {
              width: '1.25rem',
              position: 'relative'
            }
          }, conversation != null && conversation.unreadMessages > 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
            className: "badge"
          }, /*#__PURE__*/React.createElement("span", null, conversation.unreadMessages)), /*#__PURE__*/React.createElement(Icon, {
            name: "Message"
          })) : /*#__PURE__*/React.createElement(Icon, {
            name: "Message",
            bw: true
          })));
        }))));
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "meeting-users"
      }, this.renderUsers());
    }
  }]);

  return MeetingUsers;
}(Component);

function mapStateToProps(state) {
  return {
    services: state.Services.availableServices,
    conversations: state.Conversation.referenceConversations,
    translate: translate(state.Languages.translations),
    user: state.user.currentUser,
    meeting: state.Meetings.meeting
  };
}

export default connect(mapStateToProps)(MeetingUsers);